import httpRequest from "services/httpRequest";

const prefix = "/api/workspace-user";

export const getWorkspaceUserPage = async params => {
  const result = await httpRequest({
    url: `${prefix}`,
    method: "GET",
    params: { ...params },
  });
  if (result?.data) {
    return result?.data;
  }
  return {};
};
export const getDetails = async id => {
  const result = await httpRequest({
    url: `${prefix}/${id}`,
    method: "GET",
  });
  if (result?.data) {
    return result?.data;
  }
  return {};
};
export const createWorkspaceUser = async body => {
  return await httpRequest({
    url: `${prefix}`,
    method: "POST",
    data: body,
    successMessage: "toast.create_success",
  });
};

export const updateWorkspaceUser = async params => {
  return await httpRequest({
    url: `${prefix}/${params.workspaceId}/${params.userId}`,
    method: "PUT",
    data: params,
    successMessage: "toast.update_success",
  });
};

export const changeStatusWorkspaceUser = async params => {
  return await httpRequest({
    url: `${prefix}/${params.workspaceId}/${params.userId}/status`,
    method: "PUT",
    data: { status: params.status },
    successMessage: "toast.update_success",
  });
};

export const deleteWorkspaceUser = async params => {
  return await httpRequest({
    url: `${prefix}/${params.workspaceId}/${params.userId}`,
    method: "DELETE",
    params: { ...params },
    successMessage: "toast.delete_success",
  });
};

export const getWorkspaceUser = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params.workspaceId}/${params.userId}`,
    method: "GET",
  });
  if (result?.data) {
    return result.data;
  }
  return {};
};

export const blockWorkspaceUser = async (workspaceId, userId, params) => {
  return await httpRequest({
    url: `${prefix}/${workspaceId}/${userId}/block-user`,
    method: "PUT",
    params,
  });
};

export const loginAsUser = async (workspaceId, userId) => {
  return await httpRequest({
    url: `${prefix}/${workspaceId}/${userId}/login-as-user`,
    method: "POST",
  });
};

export const onResendingInvitationUser = async params => {
  const result = await httpRequest({
    url: `${prefix}/resending`,
    method: "POST",
    data: params,
    successMessage: "toast.resendingUserSuccessfully",
  });
  return result;
};
